import { render } from "./MypageMonthlyFoodsRankingQuestionDialog.vue?vue&type=template&id=3ba43997&scoped=true&ts=true"
import script from "./MypageMonthlyFoodsRankingQuestionDialog.vue?vue&type=script&lang=ts"
export * from "./MypageMonthlyFoodsRankingQuestionDialog.vue?vue&type=script&lang=ts"

import "./MypageMonthlyFoodsRankingQuestionDialog.vue?vue&type=style&index=0&id=3ba43997&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba43997"]])

export default __exports__